import { Trans } from '@lingui/macro';
import styled from '@emotion/styled';
import { DatePicker, DatePickerProps } from 'components';
import { formatDate } from './transforms';

export const placeholder = 'DD-MMM-YYYY';

export type DateProps = {
  from?: Date | null;
  to?: Date | null;
  onChange: (from?: Date | null, to?: Date | null) => void;
  sx?: DatePickerProps['sx'];
  inputVariant?: DatePickerProps['inputVariant'];
  isStopPropagationOnKeyDown?: boolean;
};

export const DateFilter = ({ from, to, onChange, ...rest }: DateProps) => {
  return (
    <FromTo>
      <DatePicker
        {...rest}
        id="filter-from"
        placeholder={placeholder}
        initialDate={formatDate(from)}
        onBlur={date => {
          onChange(date?.toDate(), to);
        }}
      />
      <span>
        <Trans>to</Trans>
      </span>
      <DatePicker
        {...rest}
        id="filter-to"
        placeholder={placeholder}
        initialDate={formatDate(to)}
        onBlur={date => {
          onChange(from, date?.toDate());
        }}
      />
    </FromTo>
  );
};

const FromTo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  > div {
    min-width: 186px;
  }
  > span {
    height: 56px;
    display: flex;
    align-items: center;
  }
`;
